import React from 'react';
import { DisplayStart, FormControl, SearchInput, TemplateListBox, TemplateMainCategory, TemplateSize, TemplateSubCategory } from '../StyledComponents';
import { Grid } from '@mui/material';
function AddtionalElementsContets(props) {
    return (
        <>
            <div className="px-10px" style={{paddingBottom:"15px"}}>
                <DisplayStart>
                    <SearchInput type="text" placeholder='Search all sizes' />
                </DisplayStart>
            </div>
            <div className='dialog-scroll'>

            </div>
        </>
    );
}

export default AddtionalElementsContets;